var path = 'common/components/notifications/notifications.html';
var html = "<div class=\"notifications\">\n    <div ng-repeat=\"note in $ctrl.notifications\" class=\"notification\" ng-class=\"{'notify-info': note.info, 'notify-error': note.error, 'notify-success': note.success, 'notify-warning': note.warning}\">\n        <p class=\"notification-message\">{{note.message}}</p>\n        <div class=\"notification-actions\">\n            <i class=\"fa fa-times\" aria-hidden=\"true\" ng-click='$ctrl.resolve(note)'></i>\n        </div>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./common/components/notifications/notifications.html
// module id = ./common/components/notifications/notifications.html
// module chunks = 0